import { clsx } from 'clsx';
import { V2 } from 'engine/lib/V2';
import { FILTER_INNER_DROP_SHADOW_ID } from 'game/defs/FilterInnerDropShadow';
import { ModuleType } from 'game/state/BotState';
import { SevenSegment } from '../SevenSegment';
import { ModuleComponentProps } from './ModuleProps';
import { moduleStyles } from './moduleStyles';

const SCALE = 100;

const changePosition = (position: V2, key: 0 | 1, howMany: number) => {
  position[key] += howMany * SCALE;
};

export const MoveToModuleComponent: React.FC<ModuleComponentProps<ModuleType.MoveTo>> = ({
  module,
  bot,
  onGrabStart,
  grabbing,
}) => {
  const botState = bot.props.state;
  return (
    <>
      <path fill="#222" d="M0 0H400V600H0z" />
      <path
        fill="#fff"
        d="M300 320.32a7.29 7.29 0 107.29 7.29 7.3 7.3 0 00-7.29-7.29zm0 11.91a4.62 4.62 0 114.62-4.62 4.63 4.63 0 01-4.62 4.62z"
      />
      <path
        fill="#fff"
        d="M319.47 326.12h-4.17a15.39 15.39 0 00-14-13.82V308a1.33 1.33 0 10-2.66 0v4.31a15.39 15.39 0 00-14 13.82h-4.17a1.34 1.34 0 000 2.67h4.15a15.4 15.4 0 0014 14.13v4a1.33 1.33 0 102.66 0v-4a15.4 15.4 0 0014-14.13h4.15a1.34 1.34 0 000-2.67zM300 340.31a12.71 12.71 0 1112.7-12.7 12.71 12.71 0 01-12.7 12.7z"
      />
      <circle cx="300" cy="550" r="19.5" fill="#ff931e" />
      <path
        fill="#f15a24"
        d="M300 531a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="300" cy="551" r="9.5" />
        <path d="M300 542a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z" />
      </g>
      <circle cx="300" cy="550" r="9.5" />
      <path
        fill="#f15a24"
        d="M300 541a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
      />
      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(268.1 519.79)"
      >
        CMD
      </text>
      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(291 159.94)"
      >
        Y
      </text>
      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(103 159.81)"
      >
        X
      </text>
      <path fill="#fff" d="M350 550L330 540 330 560 350 550z" />
      <path
        fill="#666"
        d="M110 384.34l20-20V335a5 5 0 00-5-5H95a5 5 0 00-5 5v29.34zM104.34 390l-20-20H55a5 5 0 00-5 5v30a5 5 0 005 5h29.34zM165 370h-29.34l-20 20 20 20H165a5 5 0 005-5v-30a5 5 0 00-5-5zM110 395.66l-20 20V445a5 5 0 005 5h30a5 5 0 005-5v-29.34z"
        filter={`url(#${FILTER_INNER_DROP_SHADOW_ID})`}
      />
      <path
        fill="#fff"
        d="M55.59 90V52.07h47.75a8.31 8.31 0 014.41 1.21 9 9 0 013.17 3.2 8.36 8.36 0 011.18 4.35V90h-7.78V61.09a1.19 1.19 0 00-.36-.88 1.21 1.21 0 00-.88-.36H89a1.12 1.12 0 00-.81.36 1.19 1.19 0 00-.36.88V90h-7.91V61.09a1.19 1.19 0 00-.36-.88 1.12 1.12 0 00-.81-.36H64.62a1.12 1.12 0 00-.82.36 1.19 1.19 0 00-.36.88V90zM123.77 88.79a9.42 9.42 0 01-3.2-3.2 8.2 8.2 0 01-1.21-4.35V60.83a8.2 8.2 0 011.21-4.35 9.33 9.33 0 013.2-3.2 8.2 8.2 0 014.35-1.21h21a8.56 8.56 0 014.41 1.17 9 9 0 013.18 3.18 8.56 8.56 0 011.17 4.41v20.41a8.45 8.45 0 01-1.17 4.35 9.19 9.19 0 01-3.18 3.2 8.31 8.31 0 01-4.41 1.21h-21a8.2 8.2 0 01-4.35-1.21zm4.62-6.57h20.47a1.19 1.19 0 00.88-.36 1.21 1.21 0 00.36-.89V61.09a1.23 1.23 0 00-1.24-1.24h-20.47a1.21 1.21 0 00-.89.36 1.19 1.19 0 00-.36.88V81a1.23 1.23 0 001.25 1.25zM182.21 90l-20.86-37.93h9L186 80.78l15.63-28.71h9L189.67 90zM217.43 88.79a9.33 9.33 0 01-3.2-3.2 8.2 8.2 0 01-1.23-4.35V60.83a8.2 8.2 0 011.21-4.35 9.25 9.25 0 013.2-3.2 8.2 8.2 0 014.35-1.21h21a8.57 8.57 0 014.42 1.17 8.86 8.86 0 013.17 3.18 8.47 8.47 0 011.18 4.41V75H220.8v6a1.21 1.21 0 00.36.89 1.19 1.19 0 00.88.36h29.5V90h-29.76a8.2 8.2 0 01-4.35-1.21zm3.37-21h23v-6.7a1.19 1.19 0 00-.36-.88 1.21 1.21 0 00-.89-.36H222a1.23 1.23 0 00-1.24 1.24zM282.24 88.79a9.16 9.16 0 01-3.17-3.2 8.46 8.46 0 01-1.18-4.35v-41h7.79v11.83h15.17v7.78h-15.17V81a1.21 1.21 0 00.36.89 1.19 1.19 0 00.88.36h13.93V90h-14.19a8.32 8.32 0 01-4.42-1.21zM310.43 88.79a9.33 9.33 0 01-3.2-3.2 8.2 8.2 0 01-1.23-4.35V60.83a8.2 8.2 0 011.21-4.35 9.25 9.25 0 013.2-3.2 8.2 8.2 0 014.35-1.21h21a8.56 8.56 0 014.41 1.17 8.86 8.86 0 013.17 3.18 8.47 8.47 0 011.18 4.41v20.41a8.36 8.36 0 01-1.18 4.35 9.08 9.08 0 01-3.17 3.2 8.31 8.31 0 01-4.39 1.21h-21a8.2 8.2 0 01-4.35-1.21zm4.57-6.57h20.47a1.23 1.23 0 001.29-1.22V61.09a1.19 1.19 0 00-.36-.88 1.21 1.21 0 00-.89-.36H315a1.23 1.23 0 00-1.24 1.24V81a1.21 1.21 0 00.36.89 1.19 1.19 0 00.88.33z"
      />
      <rect
        width="100"
        height="40"
        x="250"
        y="370"
        fill="#666"
        rx="5"
        filter={`url(#${FILTER_INNER_DROP_SHADOW_ID})`}
      />

      <SevenSegment
        transform="translate(5 188)"
        digits={4}
        number={Math.round(module.config.target[0] / SCALE)}
      />
      <SevenSegment
        transform="translate(195 188)"
        digits={4}
        number={Math.round(module.config.target[1] / -SCALE)}
      />

      <rect
        className={clsx(moduleStyles.grab, { [moduleStyles.grabbing]: grabbing })}
        width={400}
        height={600}
        onMouseDown={onGrabStart}
      />

      <rect
        className={moduleStyles.hitBox}
        x={90}
        y={330}
        width={40}
        height={50}
        onClick={() => changePosition(module.config.target, 1, -1)}
      />
      <rect
        className={moduleStyles.hitBox}
        x={90}
        y={400}
        width={40}
        height={50}
        onClick={() => changePosition(module.config.target, 1, 1)}
      />
      <rect
        className={moduleStyles.hitBox}
        x={50}
        y={370}
        width={50}
        height={40}
        onClick={() => changePosition(module.config.target, 0, -1)}
      />
      <rect
        className={moduleStyles.hitBox}
        x={120}
        y={370}
        width={50}
        height={40}
        onClick={() => changePosition(module.config.target, 0, 1)}
      />

      <rect
        className={moduleStyles.hitBox}
        x={250}
        y={370}
        width={100}
        height={40}
        onClick={() => { module.config.target = [...botState.position]; }}
      />

    </>
  );
};
